<template>
  <form
    :id="id"
    :aria-label="t('referenceData.accessorials', 2)"
    class="rate-quote-accessorials flex flex-column flex-gap-1 align-items-start"
  >
    <p v-if="!internalValue.length" class="m-0">
      {{ t('common.noParam', { param: t('referenceData.accessorials', 2) }) }}
    </p>

    <RateQuoteAccessorialEdit
      v-for="(_accessorial, i) of internalValue"
      :id="`rate-result-accessorials-${i}`"
      :key="i"
      v-model="internalValue[i]"
      :available-accessorials="availableAccessorials"
      :use-additional-services-label="useAdditionalServicesLabel"
      class="w-full"
      @remove="removeAccessorial(i)"
    />

    <AddButton
      :aria-controls="id"
      :label="t('referenceData.accessorials')"
      :disabled="v$.$invalid"
      @click="addAccessorial"
    />
  </form>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue, useValidations } from '@rygen/rygen-ui/composables';
import { AccessorialCode } from '@rygen/rygen-ui/model/AccessorialCode';

import { RateQuoteAccessorial } from '@/model';

import RateQuoteAccessorialEdit from '@/components/rateShop/RateQuoteAccessorialEdit.vue';
import AddButton from '@/components/ui/AddButton.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Array as PropType<RateQuoteAccessorial[]>,
    required: false,
    default: () => [],
  },
  availableAccessorials: {
    type: Array as PropType<AccessorialCode[]>,
    required: false,
    default: () => [],
  },
  useAdditionalServicesLabel: {
    type: Boolean,
    default: () => false,
  },
});
const { id, modelValue, availableAccessorials, useAdditionalServicesLabel } =
  toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: RateQuoteAccessorial[]): void;
}>();

const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<RateQuoteAccessorial[]>) => opts,
});
const { v$, validate } = useValidations(internalValue, {});

const addAccessorial = async () => {
  if (await validate()) {
    internalValue.value.push(new RateQuoteAccessorial());
  }
};

const removeAccessorial = (i: number) => {
  internalValue.value.splice(i, 1);
};
</script>
